/**
 * What we tell a signed-out listener about signing in, in one place so it reads as one voice.
 * Every claim here is true of the API as it is (see PolicyView): change them together.
 */
export const signInCopy = {
    benefits: [
        "Fortsätt där du slutade, på alla dina enheter",
        "Se nya avsnitt från poddarna du följer",
        "Spara avsnitt till senare",
    ],
    /** Under the email field: why it is safe, and what the address is used for */
    trust: "Inget lösenord att komma ihåg eller läcka: du får en engångskod i mejlet som gäller i 15 minuter. Din e-post använder vi för att logga in dig, och annat mejl skickar vi bara om du själv säger ja.",
    trustLink: "Så skyddar vi ditt konto",
    banner: {
        title: "Ta med dig dina poddar",
        text: "Logga in utan lösenord så följer din plats och dina favoriter med på alla enheter. Det är gratis.",
    },
    player: "Logga in för att fortsätta på alla dina enheter",
    account: "Logga in för att se ditt konto. Det är gratis och du behöver inget lösenord.",
};
